import { enqueueSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { JSON_SPACE } from 'constants/json'
import { toAgentErrorMessage } from 'features/yieldbirdWrapperAgent/api/errors'
import { getReportDetails } from 'features/yieldbirdWrapperAgent/api/requests'
import { enqueueSnackbarForRestError } from 'providers/tanstack-query-rest/errors'

import type { Report } from 'features/yieldbirdWrapperAgent/api/types'

type UseOpenDiagnostics = {
  open: (jobId: Report['jobId']) => Promise<void>
}

const OBJECT_URL_LIFETIME: number = 60_000 // [ms]; 1 minute

const toJsonBlob = (value: unknown): Blob =>
  new Blob([JSON.stringify(value, null, JSON_SPACE)], { type: 'application/json' })

const showInTab = (tab: Window, file: Blob): void => {
  const objectUrl: string = URL.createObjectURL(file)

  tab.location.href = objectUrl
  setTimeout((): void => URL.revokeObjectURL(objectUrl), OBJECT_URL_LIFETIME)
}

export const useOpenDiagnostics = (): UseOpenDiagnostics => {
  const { t } = useTranslation('features/yieldbirdWrapperAgent')

  const open = async (jobId: Report['jobId']): Promise<void> => {
    const tab: null | Window = window.open('', '_blank')

    if (tab === null) {
      enqueueSnackbar(t('reports.popupBlocked'), { variant: 'error' })

      return
    }

    try {
      showInTab(tab, toJsonBlob(await getReportDetails(jobId)))
    } catch (error) {
      tab.close()
      enqueueSnackbarForRestError(error, toAgentErrorMessage)
    }
  }

  return { open }
}
